import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  Modal,
  Box,
  ImageListItem,
  Divider,
  FormControl,
  Select,
  MenuItem,
  Menu,
  Button,
  Stack,
  TextField,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Tooltip } from "@mui/material";
import Close from "../../../assets/icons/Close.svg";
import ButtonClose from "../../../assets/icons/ButtonClose.svg";
import Calander from "../../../assets/icons/Calander.svg";
import moment from "moment";
import { DateEditCalendar } from "../../CommonComponent/DateEditCalendar";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import dayjs from "dayjs";

import {
  getChecklistTypeMastersList,
  getDepartmentMasterList,
  updateQuestionMasterList,
  setIsOpenModelEditQuestionMaster,
} from "../../../redux/actions/mastersAction";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "1px solid #FFFFFF",
  boxShadow: 24,
  padding: "20px 0px 20px 0px",
  borderRadius: "12px",
  outline: "none",
};

const EditQuestionMasterModel = (Props) => {
  const dispatch = useDispatch();
  const CompanyID = localStorage.getItem("companyID");

  const isSaveButtonLoading = useSelector(
    (state) => state?.user?.isSaveButtonLoading
  );

  const EditQuestionMasterModel = useSelector(
    (state) => state?.masters?.EditQuestionMasterModel
  );

  const checklistTypeMasterData = useSelector(
    (state) => state?.masters?.checklistTypeMasterData
  );

  const departmentMasterData = useSelector(
    (state) => state?.masters?.departmentMasterData
  );
  const [CurrentDepartmentName, setCurrentDepartmentName] = useState("");
  const [ChecklistType, setChecklistType] = useState("");
  const [Department, setDepartment] = useState("");
  const [Question, setQuestion] = React.useState("");

  useEffect(() => {
    setChecklistType(
      EditQuestionMasterModel?.EditRowDataModel?.checklist_type_id || ""
    );
    setDepartment(
      EditQuestionMasterModel?.EditRowDataModel?.department_info?.name
    );
    setQuestion(EditQuestionMasterModel?.EditRowDataModel?.question);
  }, [EditQuestionMasterModel]);

  const handleChangeQuestion = (event) => {
    setQuestion(event.target.value);
  };
  const handleChangeChecklistType = (event) => {
    const filteredChecklistType = checklistTypeMasterData.filter(
      (row) => row?.id === event.target.value
    );
    setCurrentDepartmentName(filteredChecklistType[0]);
    setDepartment(filteredChecklistType[0]?.department_info?.name);
    setChecklistType(event.target.value);
  };

  const handleChangeDepartment = (event) => {
    setDepartment(event.target.value);
  };

  const handleSaveQuestion = async (event) => {
    if (ChecklistType !== "" && Department !== "" && Question !== "") {
      dispatch(
        updateQuestionMasterList({
          question: Question,
          checklist_type_id: ChecklistType,
          department_id:
            CurrentDepartmentName === ""
              ? EditQuestionMasterModel?.EditRowDataModel?.department_id
              : CurrentDepartmentName?.department_id,
          company_id: CompanyID,
          id: EditQuestionMasterModel?.EditRowDataModel?.id,
        })
      );
    } else {
      toast.error("Please enter all details to proceed");
    }
  };

  return (
    <Modal
      open={EditQuestionMasterModel?.isOpenEditModel}
      onClose={() => {
        const payload = {
          isOpenEditModel: false,
          EditRowDataModel: [],
        };
        dispatch(setIsOpenModelEditQuestionMaster(payload));
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            marginBottom: "20px",
          }}
        >
          <Box sx={{ width: "90%" }}>
            <Typography
              align="center"
              sx={{
                color: "#212121",
                fontSize: "22px",
                fontWeight: 500,
                position: "relative",
                left: "35px",
              }}
            >
              Edit Question
            </Typography>
          </Box>
          <Box
            sx={{
              width: "10%",
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              mr: 3,
            }}
          >
            <ImageListItem
              sx={{ cursor: "pointer", width: "15px" }}
              onClick={() => {
                const payload = {
                  isOpenEditModel: false,
                  EditRowDataModel: [],
                };
                dispatch(setIsOpenModelEditQuestionMaster(payload));
              }}
            >
              <img src={Close} alt="" />
            </ImageListItem>
          </Box>
        </Box>
        <Divider />
        <Box sx={{ padding: "20px" }}>
          <Box sx={{ marginBottom: "15px" }}>
            <FormControl
              fullWidth
              sx={{
                background: "#F3F6F9",
                borderRadius: "10px",
              }}
            >
              <Select
                value={ChecklistType}
                onChange={handleChangeChecklistType}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                sx={{
                  height: "40px",
                  borderRadius: "10px",
                  fontSize: "14px",
                  color: "#000000",
                  border: "none",
                  " .css-16ak6nl-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root":
                    {
                      height: "100%",
                      width: "41rem",
                      lineHeight: "none",
                      borderRadius: "10px",
                      backgroundColor: "#F3F6F9",
                    },
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              >
                <MenuItem value="" disabled>
                  Select Checklist type
                </MenuItem>
                {checklistTypeMasterData.map((row) => (
                  <MenuItem value={row?.id}>
                    {row?.name} ({row?.department_info?.name})
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ marginBottom: "15px" }}>
            {/* <FormControl
              fullWidth
              sx={{
                background: "#F3F6F9",
                borderRadius: "10px",
              }}
            >
              <Select
                value={Department}
                onChange={handleChangeDepartment}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                sx={{
                  height: "40px",
                  borderRadius: "10px",
                  fontSize: "14px",
                  color: "#000000",
                  border: "none",
                  " .css-16ak6nl-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root":
                    {
                      height: "100%",
                      width: "41rem",
                      lineHeight: "none",
                      borderRadius: "10px",
                      backgroundColor: "#F3F6F9",
                    },
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              >
                <MenuItem value="" disabled>
                  Select Department Name
                </MenuItem>
                {departmentMasterData.map((row) => (
                  <MenuItem value={row?.id}>{row?.name}</MenuItem>
                ))}
              </Select>
            </FormControl> */}
            <TextField
              id="outlined-basic"
              variant="outlined"
              readOnly
              // defaultValue={Department}
              placeholder="Department Name"
              type="text"
              value={Department}
              // onChange={handleChangeAddChecklistType}
              sx={{
                width: "100%",
                borderRadius: "10px",
                backgroundColor: "#F3F6F9",
                border: "none",
                cursor: "not-allowed",
                pointerEvents: "none",
                "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                  border: "0px solid #F3F6F9",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
                ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input ": {
                  height: "0.5rem",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          <Box sx={{ marginBottom: "15px" }}>
            <FormControl
              fullWidth
              sx={{
                background: "#F3F6F9",
                borderRadius: "10px",
              }}
            >
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="Add Question"
                type="text"
                value={Question}
                onChange={handleChangeQuestion}
                sx={{
                  width: "100%",
                  borderRadius: "10px",
                  backgroundColor: "#F3F6F9",
                  border: "none",
                  outline: "none",
                  ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
                    height: "0.4375em",
                  },
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                    borderRadius: "10px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "& .css-1v4ccyo": {
                    height: "2.5rem",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </FormControl>
          </Box>

          <Box
            sx={{
              marginTop: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "15px",
            }}
          >
            <Box>
              <Button
                // variant="contained"
                sx={{
                  fontSize: "15px",
                  border: "1px solid #26875C",
                  fontWeight: 600,
                  width: "8rem",
                  // backgroundColor: "#26875C",
                  padding: "10px 5px 10px 5px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#26875C",
                  // ":hover": {
                  //   backgroundColor: "#26875C",
                  // },
                }}
                onClick={() => {
                  const payload = {
                    isOpenEditModel: false,
                    EditRowDataModel: [],
                  };
                  dispatch(setIsOpenModelEditQuestionMaster(payload));
                }}
              >
                Cancel
              </Button>
            </Box>
            <Box>
              <LoadingButton
                onClick={handleSaveQuestion}
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  width: "8rem",
                  border: "1px solid #26875C",
                  backgroundColor: "#26875C",
                  padding: "10px 5px 10px 5px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#FFFFFF",
                  ":hover": {
                    backgroundColor: "#26875C",
                  },
                }}
                loading={isSaveButtonLoading}
              >
                Save
              </LoadingButton>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditQuestionMasterModel;
